import React from 'react'
import { Redirect } from 'common-tools/ReachRouter'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import Loadable from 'react-loadable'
import { LoadableLoading } from 'common-controls/App/LoadableLoading'
// import Admin from 'common-views/Admin/Admin'

const Admin = Loadable({
  loader: () => import('common-views/Admin/Admin'),
  loading: (props) => {
    return <LoadableLoading {...props} />
  }
})

class AdminRoutePlain extends React.Component {
  render () {
    const { SessionToken, location } = this.props

    if (!SessionToken) {
      return <Redirect from='/Admin' to={`/Login?returnURL=${location ? location.pathname : ''}`} />
    }

    return React.createElement(Admin, this.props)
  }
}

export const AdminRoute = compose(
  ReduxWrapper([
    sh.SessionToken
  ])
)(AdminRoutePlain)
